





































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import BpcInput from '@shared/components/forms/inputs/input/input.vue';

@Component({
  name: 'bpc-pos-send-ticket-by-email-modal',
  components: {
    BpcInput,
  },
})
export default class PosSendTicketByEmailModal extends Vue {
  // PROPS
  @Prop({ type: Boolean, default: false }) readonly loading: boolean;
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({ type: Boolean, default: false }) readonly closeDisabled: boolean;
  @Prop({ type: Boolean, default: false }) readonly confirmDisabled: boolean;
  @Prop({ type: String, default: '' }) readonly emailAddress: string;
  @Prop({ type: Number, required: true }) readonly ticketId!: number;
  @Prop({ type: Number, required: true }) readonly posSessionId!: number;

  // DATA
  emailAddressSendTicket = '';
  sendingEmail = false;

  // COMPUTED
  // LIFECYCLE
  // METHODS

  closeModal() {
    this.$emit('close');
  }

  mounted() {
    this.emailAddressSendTicket = this.emailAddress;
  }

  async onConfirm() {
    this.sendingEmail = true;
    try {
      const sendTicket = await this.$posService.sendTicketByEmail(
        this.posSessionId,
        this.ticketId,
        this.emailAddressSendTicket,
      );
      this.$emit('close');
      this.emailAddressSendTicket = '';
      this.sendingEmail = false;
    } catch (error) {
      this.sendingEmail = false;
    }
  }

  // WATCHERS
  @Watch('showModal')
  onEmailAddressChange() {
    if (this.showModal) {
      this.emailAddressSendTicket = this.emailAddress;
    }
  }
}
